/** Multi-floor helpers for dine-in table layout. */
export const DEFAULT_MAIN_FLOOR_ID = "main";
export const DEFAULT_MAIN_FLOOR_NAME = "Main";
export function ensureFloorPlans(floorPlans) {
    if (floorPlans && floorPlans.length > 0) {
        return floorPlans;
    }
    return [{ _id: DEFAULT_MAIN_FLOOR_ID, name: DEFAULT_MAIN_FLOOR_NAME }];
}
export function resolveTableFloorId(table) {
    return table.floor_plan_id || DEFAULT_MAIN_FLOOR_ID;
}
export function filterTablesByFloor(tables, floorPlanId) {
    return tables.filter((t) => resolveTableFloorId(t) === floorPlanId);
}
export const ALL_TABLES_AREA_ID = "__all__";
export const ALL_TABLES_AREA_LABEL = "All Tables";
export const UNASSIGNED_AREA_ID = "__unassigned__";
export const UNASSIGNED_AREA_LABEL = "Unassigned";
export function resolveTableArea(table) {
    return (table.area || "").trim();
}
/** One tab when no areas set; otherwise one tab per distinct area (+ Unassigned if needed). */
export function groupTablesByArea(tables) {
    const withArea = new Map();
    const withoutArea = [];
    for (const t of tables) {
        const area = resolveTableArea(t);
        if (!area) {
            withoutArea.push(t);
            continue;
        }
        if (!withArea.has(area))
            withArea.set(area, []);
        withArea.get(area).push(t);
    }
    if (withArea.size === 0) {
        return [
            {
                id: ALL_TABLES_AREA_ID,
                label: ALL_TABLES_AREA_LABEL,
                tables: [...tables],
            },
        ];
    }
    const groups = Array.from(withArea.entries())
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([label, groupTables]) => ({
        id: label,
        label,
        tables: groupTables,
    }));
    if (withoutArea.length) {
        groups.push({
            id: UNASSIGNED_AREA_ID,
            label: UNASSIGNED_AREA_LABEL,
            tables: withoutArea,
        });
    }
    return groups;
}
//# sourceMappingURL=floor_plans.js.map